
import React from 'react';
import Header from "./Header";

const Logout = props => {
  return (<Header
    do_logout={true}
    history={props.history}
  />);
}

export { Logout };
